var _rect, _path, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaypal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 40,
    viewBox: "0 0 60 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 40,
    rx: 6,
    fill: "#003087"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 10h10v4h-10v-4zm-8 0h6v4h-6v-4zm14 6h8v4h-8v-4zm-14 0h12v4h-12v-4z",
    fill: "#009CDE"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 30,
    y: 35,
    fontFamily: "Arial",
    fontSize: 8,
    fill: "white",
    textAnchor: "middle"
  }, "PayPal")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaypal);
export default __webpack_public_path__ + "static/media/paypal.3f1ba2d3b536d812a122080975c09c1f.svg";
export { ForwardRef as ReactComponent };